module.exports = __webpack_public_path__ + "img/profit.e476dcd2.png";